import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { all_routes } from '../router/all_routes';
import ImageWithBasePath from '../../core/common/imageWithBasePath';
import CopyRightInfo from '../../core/common/copyRightInfo';
import HeaderLogo from '../../core/common/headerLogo';
import { API } from '../../common/Constants';
import useFetch from '../../hooks/useFetch';
import { useAuthTenant } from '../../hooks/useAuthTenant';

const ResetPasswordSuccess = () => {
  const routes = all_routes;
  const navigation = useNavigate();
  const { callFetch } = useFetch();
  const { tenant } = useAuthTenant();
  const [tenantInfo, setTenantInfo] = useState<{
    institutionName: string;
    institutionLogo: string;
  } | null>(null);

  useEffect(() => {
    if (!tenant) {
      setTenantInfo(null);
      return;
    }

    callFetch(
      API.TENANT_INFO.replace(':tenantId', tenant),
      'GET',
      { 'X-Tenant-ID': tenant },
      null,
      null
    )
      .then((response) => {
        if (response && response.settingGroups) {
          const brandingGroup = response.settingGroups.find(
            (group: any) => group.category === 'BRANDING'
          );

          if (brandingGroup && brandingGroup.settings) {
            const institutionNameSetting = brandingGroup.settings.find(
              (setting: any) => setting.settingKey === 'institution_name'
            );
            const institutionLogoSetting = brandingGroup.settings.find(
              (setting: any) => setting.settingKey === 'institution_logo'
            );

            setTenantInfo({
              institutionName: institutionNameSetting?.currentValue || 'Institution',
              institutionLogo: institutionLogoSetting?.currentValue || ''
            });
          } else {
            setTenantInfo(null);
          }
        } else {
          setTenantInfo(null);
        }
      })
      .catch(() => {
        setTenantInfo(null);
      });
  }, [tenant, callFetch]);

  const navigationPath = () => {
    navigation(routes.login);
  };
  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-5">
            <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent">
              <div>
                <ImageWithBasePath src="assets/img/bg/authentication-bg-07.svg" alt="Img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-md-7 mx-auto vh-100">
                <form  className="vh-100">
                  <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                    <div className=" mx-auto mb-5 text-center">
                      <HeaderLogo 
                        url={tenantInfo?.institutionLogo}
                        name={tenantInfo?.institutionName}
                        size="L"
                      />
                    </div>
                    <div className="">
                      <div className="text-center mb-3">
                        <ImageWithBasePath
                          src="assets/img/icons/success-tick.svg"
                          alt="icon"
                          className="img-fluid mb-3"
                        />
                        <h2 className="mb-2">Success</h2>
                        <p className="mb-0">
                          Your new password has been successfully saved
                        </p>
                      </div>
                      <div className="mb-3">
                        <button type="submit" onClick={navigationPath} className="btn btn-primary w-100">
                          Back to Sign In
                        </button>
                      </div>
                    </div>
                    <div className="mt-5 pb-4 text-center">
                      <CopyRightInfo/>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default ResetPasswordSuccess